import { useGet } from './useFetch'
import { useAuth } from './useAuth'

export interface PlaybackDurationDay {
  date: string
  duration_seconds: number
}

export interface ClinicPlaybackDurationReportRow {
  clinic_id: number
  clinic_name: string
  days: PlaybackDurationDay[]
  total_duration_seconds: number
}

export interface PlaybackDurationReport {
  startDate: string
  endDate: string
  dates: string[]
  clinics: ClinicPlaybackDurationReportRow[]
}

interface ApiEnvelope<T> {
  success: boolean
  data?: T
  error?: { code: string; message: string }
}

interface UsePlaybackDurationReportParams {
  providerId?: number
  clinicId?: number
  startDate?: string
  endDate?: string
}

export function usePlaybackDurationReport(params: UsePlaybackDurationReportParams = {}) {
  const { token } = useAuth()
  const { providerId, clinicId, startDate, endDate } = params

  const queryParams: Record<string, unknown> = {}
  if (providerId) queryParams.providerId = providerId
  if (clinicId) queryParams.clinicId = clinicId
  if (startDate) queryParams.startDate = startDate
  if (endDate) queryParams.endDate = endDate

  const shouldFetch = Boolean(token && startDate && endDate)

  const { data, error, mutate } = useGet<ApiEnvelope<PlaybackDurationReport>>(
    shouldFetch ? '/api/playback-duration/report' : null,
    queryParams,
    token ?? '',
  )

  return {
    report: data?.data,
    isLoading: shouldFetch && !error && !data,
    isError: error,
    mutate,
  }
}
